export const SHALLOW_SEARCH_QUERY_KEY = "shallow-search";
